<script>
import { mapActions } from 'vuex'
import Layout from "../../layouts/main";
import PageHeader from "@/components/Page-header";
import appConfig from "../../../../app.config";

/**
 * Contacts profile component
 */
export default {
  components: {
    Layout,
    PageHeader,
  },
  page: {
    title: "Contacts profile",
    meta: [{ name: "description", content: appConfig.description }],
  },
  data() {
    return {
      title: "Profile",
      items: [
        {
          text: "Users",
          href: "/",
        },
        {
          text: "Profile",
          active: true,
        },
      ],
      username: '',
      typeform: {
        passwordCurrent: '',
        password: '',
        passwordConfirm: '',
      },
      showForm: false,
      showAlert: false,
      textAlert: '',
      showInfo: false,
      textInfo: '',
      showExp: false,
      textExp: '',
      showAlertInfo: false,
      textAlertInfo: '',
      passCheck: {
        min: true,
        lower: true,
        upper: true,
        number: true,
        special: true,
        wrong: {
          icon: 'fas fa-times',
          color: 'color: #f06b78; font-weight: bold;',
        },
        right: {
          icon: 'fas fa-check',
          color: 'color: #1abc9c; font-weight: bold;',
        },
        status: false
      },
      typePass: "password",
      showMypass: false,
      typePassnew: "password",
      showMypassnew: false,
    };
  },
  watch: {
    showAlert: {
      handler: function (val, oldVal) {
        if (!val) {
          this.textAlert = '';
        }
      }
    },
    showInfo: {
      handler: function (val, oldVal) {
        if (!val) {
          this.textInfo = '';
          this.passCheck.min = true;
          this.passCheck.lower = true;
          this.passCheck.upper = true;
          this.passCheck.number = true;
          this.passCheck.special = true;
          this.passCheck.status = false;
        }
      }
    },
    showForm: {
      handler: function (val, oldVal) {
        if (!val) {
          this.typeform = {
            passwordCurrent: '',
            password: '',
            passwordConfirm: '',
          };
        }
      }
    },
    showAlertInfo: {
      handler: function (val, oldVal) {
        if (!val) {
          this.textAlertInfo = '';
        }
      }
    },
  },
  mounted() {
    this.username = JSON.parse(localStorage.getItem('user')).username;
  },
  created() {
    this.viewProfile();
  },
  methods: {
      ...mapActions('users', ['changePassword', 'profile']),
      typeForm(e) {
        if (this.typeform.password === "" || this.typeform.passwordCurrent === "") {
          this.textInfo = 'Password tidak boleh kosong';
          this.showInfo = true;
        }
        if (this.typeform.passwordCurrent === this.typeform.password) {
          this.textInfo = 'Password tidak boleh sama dengan sebelumnya';
          this.showInfo = true;
        } else if (this.typeform.password) {
          if (this.typeform.password !== this.typeform.passwordConfirm) {
            this.textInfo = 'Konfirmasi password salah';
            this.showInfo = true;
          } else {
            var pass = this.typeform.password;
            const regexLower = /^(?=.*[a-z])/;
            const regexUpper = /^(?=.*[A-Z])/;
            const regexNumber = /^(?=.*\d)/;
            const regexSpecial = /^(?=.*\W)/;
            if (pass.length < 12) {
              this.passCheck.min = false;
              this.passCheck.status = true;
            }
            if (!regexLower.test(pass)) {
              this.passCheck.lower = false;
              this.passCheck.status = true;
            }
            if (!regexUpper.test(pass)) {
              this.passCheck.upper = false;
              this.passCheck.status = true;
            }
            if (!regexNumber.test(pass)) {
              this.passCheck.number = false;
              this.passCheck.status = true;
            }
            if (!regexSpecial.test(pass)) {
              this.passCheck.special = false;
              this.passCheck.status = true;
            }
            if (this.passCheck.status) {
              this.showInfo = true;
            }
          }
        }
        if (!this.showInfo) {
          this.changePass();
        }
      },
      changePass() {
        this.showAlertInfo = true; this.textAlertInfo = "Loading...";
        this.changePassword(this.typeform).then((response) => {
          this.showAlertInfo = false;
          this.showForm = false;
          this.textAlert = "Password has been changed";
          this.showAlert = true;
        }).catch((error) => {
          this.showAlertInfo = false;
          this.textInfo = error;
          this.showInfo = true;
        })
      },
      viewProfile() {
        this.profile().then((response) => {
          if (response.data !== null) {
            var expired = response.data.expired;
            if (expired.status) {
              this.textExp = 'Your current password will be expired in: ' + expired.remainDay +
              ' day (' + expired.expDate + '). Please change the password before the expiration date.';
              this.showExp = true;
            } else {
              this.showExp = false;
            }
          }
        }).catch((error) => {
          this.formError = error;
          this.isFormError = true;
        })
      },
      showPass() {
        if(this.showMypass) {
          this.typePass = "password";
          this.showMypass = false;
        } else {
          this.typePass = "text";
          this.showMypass = true;
        }
      },
      showPassnew() {
        if(this.showMypassnew) {
          this.typePassnew = "password";
          this.showMypassnew = false;
        } else {
          this.typePassnew = "text";
          this.showMypassnew = true;
        }
      }
    },
  middleware: "router-auth",
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-lg-12 col-xl-12">
        <div class="card">
          <div class="card-body text-center">
            <img
              src="@/assets/images/users/user-icon.jpg"
              class="rounded-circle avatar-xl img-thumbnail"
              alt="profile-image"
            />

            <h4 class="mt-3 mb-0">{{ username }}</h4>

            <!-- <div class="text-left mt-3">
              <div class="table-responsive">
                <table class="table table-borderless table-sm">
                  <tbody>
                    <tr>
                      <th scope="row">Username :</th>
                      <td class="text-muted"{{ username }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div> -->
            <div class="text-right mt-3">
              <b-button @click="showForm=true" variant="primary" class="text-right">Change Password</b-button>
              <p v-if="showExp">{{textExp}}</p>
            </div>
            <b-modal
              id="change-password"
              hide-header
              hide-footer
              v-model="showForm"
            >
              <b-alert
                v-model="showAlertInfo"
                class="mb-4"
                variant="info"
                dismissible
                >{{ textAlertInfo }}</b-alert
              >
              <form action="#" @submit.prevent="typeForm">
                <div class="form-group">
                    <label>Current Password</label>
                    <div class="input-group input-group-merge">
                        <input v-model="typeform.passwordCurrent" :type="typePass" name="passwordCurrent" class="form-control" placeholder="Current Password" />
                        <span class="input-group-append">
                            <button
                                type="button"
                                class="btn waves-effect waves-light btn-secondary"
                                v-on:click="showPass()"
                            >
                                <i v-if="showMypass" class="fa fa-eye"></i>
                                <i v-if="!showMypass" class="fa fa-eye-slash"></i>
                            </button>
                        </span>
                    </div>
                </div>
                <div class="form-group">
                    <label>Password</label>
                    <div class="input-group input-group-merge">
                        <input v-model="typeform.password" :type="typePassnew" name="password" class="form-control" placeholder="Password" />
                        <span class="input-group-append">
                            <button
                                type="button"
                                class="btn waves-effect waves-light btn-secondary"
                                v-on:click="showPassnew()"
                            >
                                <i v-if="showMypassnew" class="fa fa-eye"></i>
                                <i v-if="!showMypassnew" class="fa fa-eye-slash"></i>
                            </button>
                        </span>
                    </div>
                </div>
                <div class="form-group">
                    <label>Confirm Password</label>
                    <div class="input-group input-group-merge">
                        <input v-model="typeform.passwordConfirm" :type="typePassnew" name="passwordConfirm" class="form-control" placeholder="Confirm Password" />
                        <span class="input-group-append">
                            <button
                                type="button"
                                class="btn waves-effect waves-light btn-secondary"
                                v-on:click="showPassnew()"
                            >
                                <i v-if="showMypassnew" class="fa fa-eye"></i>
                                <i v-if="!showMypassnew" class="fa fa-eye-slash"></i>
                            </button>
                        </span>
                    </div>
                </div>
                <div class="form-group mb-0 text-right">
                  <div>
                      <button type="submit" class="btn btn-primary" :disabled="showAlertInfo">Change</button>
                      <button type="button" v-on:click="showForm=false" class="btn btn-secondary m-l-5 ml-1">Cancel</button>
                  </div>
                </div>
              </form>
            </b-modal>

            <b-modal
              id="warning-alert-modal"
              body-class="p-4"
              hide-header
              hide-footer
              size="sm"
              v-model="showInfo"
            >
              <div class="text-center">
                <i class="bx bxs-no-entry h1 text-warning"></i>
                <h4 class="mt-2">Kesalahan</h4>
                <p class="mt-3">{{textInfo}}</p>
                <p class="mt-3" v-if="passCheck.status">
                  <span :style="passCheck.min?passCheck.right.color:passCheck.wrong.color">
                    <i :class="passCheck.min?passCheck.right.icon:passCheck.wrong.icon"></i> Minimal 12 karakter
                  </span><br/>
                  <span :style="(passCheck.lower&&passCheck.upper)?passCheck.right.color:passCheck.wrong.color">
                    <i :class="(passCheck.lower&&passCheck.upper)?passCheck.right.icon:passCheck.wrong.icon"></i> 
                    Terdiri dari huruf kapital dan huruf kecil
                  </span><br/>
                  <!-- <span :style="passCheck.upper?passCheck.right.color:passCheck.wrong.color">
                    <i :class="passCheck.upper?passCheck.right.icon:passCheck.wrong.icon"></i> Uppercase letters
                  </span><br/> -->
                  <span :style="passCheck.number?passCheck.right.color:passCheck.wrong.color">
                    <i :class="passCheck.number?passCheck.right.icon:passCheck.wrong.icon"></i> Terdapat angka
                  </span><br/>
                  <span :style="passCheck.special?passCheck.right.color:passCheck.wrong.color">
                    <i :class="passCheck.special?passCheck.right.icon:passCheck.wrong.icon"></i> Terdapat simbol
                  </span>
                </p>
                <button
                  type="button"
                  class="btn btn-warning my-2"
                  v-on:click="showInfo=false"
                >OK</button>
              </div>
            </b-modal>

            <b-modal
              id="info-alert-modal"
              body-class="p-4"
              hide-header
              hide-footer
              size="sm"
              v-model="showAlert"
            >
              <div class="text-center">
                <i class="bx bxs-info-circle h1 text-info"></i>
                <h4 class="mt-2">Info</h4>
                <p class="mt-3">{{textAlert}}</p>
                <button
                  type="button"
                  class="btn btn-info my-2"
                  v-on:click="showAlert=false"
                >OK</button>
              </div>
            </b-modal>
          </div>
          <!-- end card-box -->
        </div>
      </div>
      <!-- end col-->
    </div>
    <!-- end row-->
  </Layout>
</template>
